export class FindAllTablesError {
  public static readonly type = '[Project/Tables/List] FindAllTablesError';
  constructor(public readonly error: Error) {}
}
